import type { ExpertRowItem } from '@highereducation/hen-ui';

/**
 * Maps a contributor-shaped object to an `ExpertRowItem`.
 * Uses `uri` for the card href; callers can spread and override individual
 * fields (e.g. `occupation`) when the default `roles.join(' / ')` isn't
 * sufficient.
 */
export function contributorToExpertItem(contributor: {
  id: string | number;
  name: string;
  roles: string[];
  imageSrc?: string;
  imageAlt?: string;
  uri?: string;
  highlight?: { label: string; text: string };
}): ExpertRowItem {
  return {
    id: String(contributor.id),
    name: contributor.name,
    occupation: contributor.roles.join(' / '),
    imageSrc: contributor.imageSrc,
    imageAlt: contributor.imageAlt,
    href: contributor.uri ?? undefined,
    highlight: contributor.highlight,
  };
}
